import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import reasonsModel from "../../models/reasons.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: reasonsData, mutate: reloadReasonsData, isLoading } = useSWR(
        queryParams || null,
        () => reasonsModel.list(queryParams),
        config.swrConfig
    );

    const columns =  [
        {
            Header: "Type",
            accessor: "type",
            className: "col"
        },
        {
            Header: "Reason",
            accessor: "reason",
            className: "col"
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/reasons/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/reasons/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.type)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if( result.isConfirmed){
                setShowLoader(true);
                await reasonsModel.destroy(id).then((res) => {
                    reloadReasonsData();
                    helper.sweetalert.toast(`${title} deleted Successfully`);
                });
                setShowLoader(false);
    }});
    };

    return (
        <>
            <Heading title="Reasons" showLoader={isLoading || showLoader}>
               
                <Link className="btn btn-primary btn-sm" href="/reasons/create">
                <i className="bi bi-plus"/>  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Cancellation-reason Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={reasonsData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={reasonsData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
